<script lang="ts">
  import { Hospital, Episodios, type Episodio } from '../lib/api';

  let episodios = $state<Episodio[]>([]);
  let error = $state<string | null>(null);
  let nuevaAlta = $state<any>({
    episodioId: '', pacienteId: '', diagnosticoEgreso: '', condicionEgreso: 'MEJORADO',
    indicaciones: '', recetas: '', cuidadosEnCasa: '', proximaCita: '', firmadaPor: ''
  });
  let ultimaCreada = $state<string | null>(null);

  async function cargar() {
    try { episodios = await Episodios.abiertos('HOSPITALIZACION'); }
    catch (e:any) { error = e?.message; }
  }

  async function firmar(e: SubmitEvent) {
    e.preventDefault();
    try {
      const r = await Hospital.altaFirmar({ ...nuevaAlta });
      ultimaCreada = r?.episodioId ?? nuevaAlta.episodioId;
      nuevaAlta = { episodioId:'', pacienteId:'', diagnosticoEgreso:'', condicionEgreso:'MEJORADO', indicaciones:'', recetas:'', cuidadosEnCasa:'', proximaCita:'', firmadaPor:'' };
      await cargar();
    } catch (e:any) { error = e?.message; }
  }

  function seleccionar(ep: Episodio) {
    nuevaAlta = { ...nuevaAlta, episodioId: ep.id!, pacienteId: ep.pacienteId };
  }

  $effect(() => { cargar(); });
</script>

<section>
  <header><h2>Altas hospitalarias</h2><button onclick={cargar}>Recargar</button></header>
  {#if error}<p class="err">⚠ {error}</p>{/if}

  <h3>Episodios activos de hospitalización</h3>
  <table>
    <thead><tr><th>Episodio</th><th>Paciente</th><th>Inicio</th><th></th></tr></thead>
    <tbody>
      {#each episodios as ep (ep.id)}
        <tr class:sel={ep.id===nuevaAlta.episodioId}><td><small>{ep.id}</small></td><td>{ep.pacienteId}</td><td>{ep.abiertoEn?.slice(0,16).replace('T',' ') ?? ''}</td><td><button onclick={() => seleccionar(ep)}>Dar de alta</button></td></tr>
      {:else}<tr><td colspan="4" class="empty">Sin pacientes hospitalizados activos.</td></tr>{/each}
    </tbody>
  </table>

  {#if nuevaAlta.episodioId}
    <h3>Firma de alta · episodio {nuevaAlta.episodioId.slice(0,8)}…</h3>
    <form onsubmit={firmar}>
      <div class="row">
        <label>Condición:
          <select bind:value={nuevaAlta.condicionEgreso}>
            <option>MEJORADO</option><option>IGUAL</option><option>EMPEORADO</option><option>FALLECIDO</option><option>ALTA_VOLUNTARIA</option><option>TRASLADO</option>
          </select>
        </label>
        <label>Firmada por: <input bind:value={nuevaAlta.firmadaPor} required/></label>
        <label>Próxima cita: <input type="datetime-local" bind:value={nuevaAlta.proximaCita}/></label>
      </div>
      <label class="full">Diagnóstico de egreso<textarea bind:value={nuevaAlta.diagnosticoEgreso} required rows="2"></textarea></label>
      <label class="full">Indicaciones<textarea bind:value={nuevaAlta.indicaciones} rows="3"></textarea></label>
      <label class="full">Recetas<textarea bind:value={nuevaAlta.recetas} rows="3"></textarea></label>
      <label class="full">Cuidados en casa<textarea bind:value={nuevaAlta.cuidadosEnCasa} rows="2"></textarea></label>
      <button class="primary" type="submit">Firmar alta y cerrar episodio</button>
    </form>
  {/if}

  {#if ultimaCreada}
    <p class="ok">✓ Alta firmada. <a href={Hospital.altaImprimibleUrl(ultimaCreada)} target="_blank" rel="noopener">Abrir resumen imprimible</a></p>
  {/if}
</section>

<style>
  header { display:flex; justify-content:space-between; align-items:center }
  header button { padding:.45rem .8rem; border:0; background:#0d6efd; color:#fff; border-radius:8px; cursor:pointer }
  table { width:100%; border-collapse:collapse; margin-bottom:1rem }
  th, td { padding:.5rem .6rem; border-bottom:1px solid #eee; text-align:left; font-size:.9rem }
  tr.sel { background:#e7f0ff }
  .row { display:flex; gap:1rem; flex-wrap:wrap; margin:.5rem 0 }
  label { display:flex; flex-direction:column; gap:.3rem; font-size:.9rem }
  label.full { display:block; margin:.8rem 0 }
  textarea, input, select { padding:.45rem; border:1px solid #ccc; border-radius:6px; font:inherit; width:100% }
  .row input, .row select { width:auto }
  .primary { padding:.6rem 1.2rem; border:0; background:#1a9850; color:#fff; border-radius:8px; cursor:pointer; font-weight:600 }
  .err { color:#b00020 } .ok { color:#1a6b1a; font-weight:600 } .empty { color:#888; text-align:center; font-style:italic }
  td button { padding:.25rem .6rem; border-radius:6px; border:0; background:#0d6efd; color:#fff; cursor:pointer; font-size:.8rem }
  h3 { margin-top:1.5rem }
</style>
